module.exports = __webpack_public_path__ + "img/ALLOSURVIE_App_Picto_AjoutEcran_iOS.f0170dac.svg";